var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("accessible-tabs", [
    _c(
      "ul",
      { staticClass: "filter-items", attrs: { role: "tablist" } },
      [
        _vm._t("default", null, {
          active: _vm.currentTab ? _vm.currentTab.id : undefined,
          click: _vm.setTab,
          move: _vm.goToTab,
        }),
        _vm._v(" "),
        _vm.useAll
          ? _c(
              "li",
              {
                staticClass: "filter-item",
                class: [{ active: !_vm.currentTab }],
                attrs: { role: "presentation" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "tab-group-button",
                    attrs: {
                      id: "exp-filter-all",
                      href: "",
                      role: "tab",
                      "aria-selected": !_vm.currentTab,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.setTab()
                      },
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "right", 39, $event.key, [
                              "Right",
                              "ArrowRight",
                            ])
                          ) {
                            return null
                          }
                          if ("button" in $event && $event.button !== 2) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.goToTab(_vm.constants.NEXT_TEXT)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "left", 37, $event.key, [
                              "Left",
                              "ArrowLeft",
                            ])
                          ) {
                            return null
                          }
                          if ("button" in $event && $event.button !== 0) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.goToTab(_vm.constants.PREVIOUS_TEXT)
                        },
                      ],
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.dictionary.all) + "\n      "
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.tabs, function (tab, i) {
          return _c(
            "li",
            {
              key: tab.id,
              staticClass: "filter-item",
              class: [
                {
                  active: _vm.currentTab && _vm.currentTab.id === tab.id,
                  disabled: tab.isDisabled,
                },
              ],
              attrs: { role: "presentation" },
            },
            [
              _c(
                "a",
                {
                  staticClass: "tab-group-button",
                  attrs: {
                    id: "exp-filter-" + i,
                    href: "",
                    role: "tab",
                    "aria-selected":
                      _vm.currentTab && _vm.currentTab.id === tab.id,
                    tabindex: tab.isDisabled ? "-1" : "0",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setTab(tab)
                    },
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "right", 39, $event.key, [
                            "Right",
                            "ArrowRight",
                          ])
                        ) {
                          return null
                        }
                        if ("button" in $event && $event.button !== 2) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.goToTab(_vm.constants.NEXT_TEXT)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "left", 37, $event.key, [
                            "Left",
                            "ArrowLeft",
                          ])
                        ) {
                          return null
                        }
                        if ("button" in $event && $event.button !== 0) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.goToTab(_vm.constants.PREVIOUS_TEXT)
                      },
                    ],
                  },
                },
                [_vm._v("\n        " + _vm._s(tab.label) + "\n      ")]
              ),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }